import type {Action} from 'redux';

// Modules
import storage from '@deezer/next/shared/utils/storage';
import type {UpdateCountryFilterAction} from '../actions/appliedFilters';
import {AppliedFiltersActionType} from '../actions/appliedFilters';

export interface AppliedFiltersState {
	country: string;
}

const INITIAL_STATE: AppliedFiltersState = {
	country: storage.get('country', 'ww'),
};

export default function appliedFiltersReducer(
	state: AppliedFiltersState = INITIAL_STATE,
	action: Action,
): AppliedFiltersState {
	switch (action.type) {
		case AppliedFiltersActionType.UPDATE_COUNTRY_FILTER:
			return {
				...state,
				country: (action as UpdateCountryFilterAction).countryCode,
			};
		default:
			return state;
	}
}
